import React, { useState } from 'react'
import { useModal } from '../../hooks/modal'
import Button from '../../components/common/Button'
import Table from '../../components/common/Table'
import Layout from '../../components/Layout'
import { useLoad } from '../../hooks/request'
import { EMPLOYEES_SALARY_LIST } from '../../urls'
import { useQueryParams } from '../../hooks/queryString'
import EmployeeTabs from './EmployeeTabs'
import EmployeeSalaryCreate from './EmployeeSalaryCreate'
import EmployeeSalaryItem from './EmployeeSalaryItem'

export default function EmployeeSalary() {
    const [page, setPage] = useState(1)
    const searchParam = useQueryParams()
    const category = useLoad(
        {
            url: EMPLOYEES_SALARY_LIST,
            params: { page, ...searchParam },
        },
        [page, searchParam],
    )

    const [showCreateModal, hideCreateModal] = useModal(
        <EmployeeSalaryCreate
            onSuccess={() => {
                hideCreateModal()
                category.request()
            }}
            onCancel={() => hideCreateModal()}
        />,
    )

    const categories = category.response ? category.response.results : []

    return (
        <Layout>
            <div className="columns">
                <div className="is-size-4 column">Ходимлар</div>

                <div className="column is-narrow">
                    <Button onClick={showCreateModal} text="Қўшиш" icon="add-outline" className="is-pulled-right is-link is-outlined" />
                </div>
            </div>
            <EmployeeTabs />

            <Table
                loading={category.loading}
                items={categories}
                columns={{
                    index: '№',
                    employee: 'Ходим',
                    paymentDate: 'Тўлов санаси',
                    amount: 'Миқдор',
                    daysWorked: 'Ишланган кунлар',
                    month: 'Ой',
                    year: 'Йил',
                    note: 'Изоҳ',
                    buttons: '',
                }}
                totalCount={categories.response ? categories.response.count : 0}
                activePage={page}
                onPageChange={setPage}
                renderItem={(item, index) => <EmployeeSalaryItem index={index} category={category} item={item} key={item.id} />}
            />
            <br />
        </Layout>
    )
}
